var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInstances = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.85 6.42c0 .497-.392.9-.875.9a.89.89 0 0 1-.875-.9c0-.497.392-.9.875-.9s.875.403.875.9m0 5.58c0 .497-.392.9-.875.9A.89.89 0 0 1 7.1 12c0-.497.392-.9.875-.9s.875.403.875.9m0 5.58c0 .497-.392.9-.875.9a.89.89 0 0 1-.875-.9c0-.497.392-.9.875-.9s.875.403.875.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.75 3C5.784 3 5 3.806 5 4.8v14.4c0 .994.784 1.8 1.75 1.8h10.5c.966 0 1.75-.806 1.75-1.8V4.8c0-.994-.784-1.8-1.75-1.8zm10.5 1.08H6.75a.71.71 0 0 0-.7.72v3.96h11.9V4.8a.71.71 0 0 0-.7-.72M6.05 14.34V9.66h11.9v4.68zm0 .9v3.96c0 .398.313.72.7.72h10.5a.71.71 0 0 0 .7-.72v-3.96z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInstances);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/instances.62921465.svg";